import { useCallback } from "react";

import { API_BASE_URL } from "@/api/api.config";
import useRestMutation from "@/remoteState/useRestMutation";

const useCreateTextSet = () => {
  const createNewTextSet = useCallback((payload) => {
    const requestParams = {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    };

    return new Request(`${API_BASE_URL}/api/v2/text-set/`, requestParams);
  }, []);
  return useRestMutation(createNewTextSet);
};

export default useCreateTextSet;
